var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9062 16.5C13.7695 16.5 15.2812 14.9883 15.2812 13.125C15.2812 11.2617 13.7695 9.75 11.9062 9.75C10.043 9.75 8.53125 11.2617 8.53125 13.125C8.53125 14.9883 10.043 16.5 11.9062 16.5ZM11.9062 11.25C12.9422 11.25 13.7812 12.0891 13.7812 13.125C13.7812 14.1609 12.9422 15 11.9062 15C10.8703 15 10.0312 14.1609 10.0312 13.125C10.0312 12.0891 10.8703 11.25 11.9062 11.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6H18.8414L18.0047 3.16641C17.9109 2.84531 17.618 2.625 17.2852 2.625H6.71484C6.37969 2.625 6.08672 2.84531 5.99531 3.16641L5.15859 6H4.5C4.08516 6 3.75 6.33516 3.75 6.75V7.40625C3.75 7.50938 3.83437 7.59375 3.9375 7.59375H5.01094L6.12891 20.6883C6.14477 20.8756 6.23042 21.0502 6.36889 21.1774C6.50736 21.3045 6.68855 21.3751 6.87656 21.375H16.9359C17.124 21.3751 17.3051 21.3045 17.4436 21.1774C17.5821 21.0502 17.6677 20.8756 17.6836 20.6883L18.8016 7.59375H20.0625C20.1656 7.59375 20.25 7.50938 20.25 7.40625V6.75C20.25 6.33516 19.9148 6 19.5 6ZM7.34531 4.21875H16.6547L17.1797 6H6.82031L7.34531 4.21875ZM16.1625 19.7812H7.65L6.60938 7.59375H17.2008L16.1625 19.7812Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessDay);
export default __webpack_public_path__ + "static/media/businessDay.1d4655faf4566dcff789bb3a799406f0.svg";
export { ForwardRef as ReactComponent };